import { createFileRoute, notFound } from '@tanstack/react-router'

/**
 * Catch-all for unmatched paths under /$projectId/$agentId.
 * Throws notFound() which bubbles to the root 404.
 */
export const Route = createFileRoute('/_app/$projectId/$agentId/$')({
  beforeLoad: () => {
    throw notFound()
  },
})
